import { Button, Checkbox } from "@mui/material";
import React, { useState } from "react";
import { setSkipPayment } from "../Redux/CartSlice";
import { useDispatch, useSelector } from "react-redux";
// import { setPointBalance } from "../Redux/Point";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import { useEffect } from "react";
import { Produts_Add } from "../api/urls";
import { Loader } from "lucide-react";

const OrderSummarySection = ({
  paymentOptions,
  // setLastToggledOption,
  // setWalletUsed,
  selectedCoupon,
  setSelectedCoupon,
  setPaymentOptions,
  totals,
  // setAmountToPay,
  // Point,
  amountToPay,
  // setConsumedBy,
  promoCodeInput,
  setPromoCodeInput,
  // balance,
  disableCheckbox,
  // consumedBy,
  walletUsed,
  minCap,
  creditUsedAmount,
  // credit,
  setCartItems,
  setCredit,
  productcart,
  setWallet,
  setPoints,
  getPromoCodeUrl,
  setAppliedCoupons,
  appliedCoupons,
  // buynow
  buyNowData,
  isBuyNow,
  quantity,
  setisApplied,
  isapplied,
  // lastToggledOption,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [couponError, setCouponError] = useState(null);
  const [couponSuccess, setCouponSuccess] = useState(null);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const balance = useSelector((state) => state.wallet.balance);
  const Point = useSelector((state) => state.point.points);
  const credit = useSelector((state) => state.credit);

  // console.log(balance, "balance");
  // console.log(Point, "point");
  // console.log(credit, "credit");
  // console.log(minCap, "minCap");
  useEffect(() => {
    if (productcart && productcart.length > 0) {
      const appliedCode = productcart[0].promo_applied;
      const appliedValue = productcart[0].promo_value;

      if (appliedCode) {
        setSelectedCoupon({
          code: appliedCode,
          value: appliedValue,
          discountedPrice: totals.sellingPrice - appliedValue,
        });
        if (isapplied) {
          setCouponSuccess(`Coupon "${appliedCode}" applied successfully!`);
        }
      } else {
        setSelectedCoupon(null);
        setPromoCodeInput("");
        setCouponSuccess(null);
        setCouponError(null);
      }
    }
  }, [
    productcart,
    totals.sellingPrice,
    isapplied,
    setPromoCodeInput,
    setSelectedCoupon,
  ]);

  // console.log("totals",totals)
  // const handlePaymentOptionChange = (option) => {
  //   const isNowSelected = !paymentOptions[option];

  //   setLastToggledOption(option);

  //   setPaymentOptions((prev) => ({
  //     ...prev,
  //     [option]: isNowSelected,
  //   }));

  //   if (option === "wallet") {
  //     if (isNowSelected) {
  //       const pointsReduction = paymentOptions.points
  //         ? totals.pointsUsedInRupees
  //         : 0;
  //       const afterPoints =
  //         (selectedCoupon?.discountedPrice || totals.finalTotal) -
  //         pointsReduction;

  //       const walletToUse = amountToPay < balance ? amountToPay : balance;

  //       setAmountToPay(afterPoints - walletToUse);
  //     } else {
  //       setWalletUsed(0);

  //       const pointsReduction = paymentOptions.points
  //         ? totals.pointsUsedInRupees
  //         : 0;
  //       const newPayable =
  //         (selectedCoupon?.discountedPrice || totals.finalTotal) -
  //         pointsReduction;

  //       setAmountToPay(newPayable);
  //     }
  //   }

  //   if (option === "points") {
  //     if (isNowSelected) {
  //       // console.log(totals.pointsUsed, "totals.pointsUsed");
  //       // console.log(Point, "Point");
  //       dispatch(setPointBalance(Point - totals.pointsUsed));
  //     } else {
  //       dispatch(setPointBalance(Point));
  //     }
  //   }

  //   if (amountToPay === 0) {
  //     setConsumedBy(option);
  //   }
  // };
  const handlePaymentOptionChange = (option) => {
    // setLastToggledOption(option);
    setPaymentOptions((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };

  const applyCoupon = async (couponCode) => {
    try {
      setIsApplyingCoupon(true);
      setCouponError(null);
      setCouponSuccess(null);

      const cartId = productcart && productcart[0]?.id;
      const currentTotal = getPromoCodeUrl().sellingPrice;
      let response;
      if (isBuyNow) {
        response = await api.patch(
          Produts_Add + `${buyNowData.id}/apply_promo_code/`,
          {
            apply_promo: true,
            promocode: couponCode,
            discounted_price: totals.sellingPrice,
          },
        );
      } else {
        response = await api.patch(getPromoCodeUrl(cartId), {
          apply_promo: true,
          promocode: couponCode,
          discounted_price: totals.totalSellingPrice,
        });
      }
      if (response.data.response === "Coupon Apllied") {
        const newCoupon = {
          code: response.data.promocode,
          value: response.data.coupon_val,
          discountedPrice: currentTotal - response.data.coupon_val,
        };
        setisApplied(true);
        setAppliedCoupons([...appliedCoupons, newCoupon]);
        setSelectedCoupon(newCoupon);
        setCouponSuccess(`Coupon "${couponCode}" applied successfully!`);
      } else {
        setCouponError("Coupon not applicable");
      }
    } catch (error) {
      console.error(
        " Coupon Apply Error:",
        error?.response?.data || error.message,
      );
      setCouponError(error?.response?.data?.message || "Coupon not applicable");
    } finally {
      setIsApplyingCoupon(false);
    }
  };
  const removeCoupon = async () => {
    try {
      setIsApplyingCoupon(true);

      if (!isBuyNow) {
        const cartId = productcart && productcart[0]?.id;
        await api.patch(getPromoCodeUrl(cartId), {
          apply_promo: false,
        });
      }
      setPromoCodeInput("");
      setSelectedCoupon("");
      setCouponSuccess(null);
      setCouponError(null);
    } catch (error) {
      console.error(
        "Failed to remove coupon:",
        error?.response?.data || error.message,
      );
      setCouponError("Failed to remove coupon");
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const finalCredit = Math.max(
    0,
    credit.data - (paymentOptions.credit ? creditUsedAmount : 0),
  ).toFixed(2);

  const finalPoints = paymentOptions.points ? Point - totals.pointsUsed : Point;

  const finalWallet = (
    paymentOptions.wallet ? balance - walletUsed : balance
  ).toFixed(2);

  const [consumedBy, setConsumedBy] = useState();
  useEffect(() => {
    if (amountToPay === 0) {
      if (paymentOptions.credit && creditUsedAmount > 0) {
        setConsumedBy("Credits");
      } else if (paymentOptions.wallet && walletUsed > 0) {
        setConsumedBy("Wallet");
      } else if (paymentOptions.points && totals.pointsUsedInRupees > 0) {
        setConsumedBy("Points");
      }
    } else {
      setConsumedBy(null);
    }
  }, [
    amountToPay,
    paymentOptions,
    creditUsedAmount,
    walletUsed,
    totals.pointsUsedInRupees,
  ]);
  return (
    <div className="summary-section">
      <h2 className="summary-title">Summary</h2>
      <div className="summary-content">
        <div className="summary-row">
          <span className="summary-label">MRP</span>
          <span className="summary-value">₹{totals.total.toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Discount</span>
          <span className="summary-value">- ₹{totals.discount.toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Selling Price</span>
          <span className="summary-value">
            ₹{(totals.total - totals.discount).toFixed(2)}
          </span>
        </div>

        <div className="summary-row">
          <span className="summary-label">Delivery Charges</span>
          <span className="summary-value">
            {totals.deliveryCharges === 0
              ? "Free"
              : `₹${totals.deliveryCharges.toFixed(2)}`}
          </span>
        </div>

        <div className="summary-row">
          <span className="summary-label">Packing Charges</span>
          <span className="summary-value">
            {totals.packingCharges === 0
              ? "Free"
              : `₹${totals.packingCharges.toFixed(2)}`}
          </span>
        </div>

        {selectedCoupon && couponSuccess && (
          <div className="summary-row discount">
            <span className="summary-label">Coupon Discount</span>
            <span className="summary-value">
              -₹{selectedCoupon.value.toFixed(2)}
            </span>
          </div>
        )}
        {paymentOptions.wallet && (
          <div className="summary-row">
            <span className="summary-label">Wallet</span>
            <span className="summary-value">- ₹{walletUsed?.toFixed(2)}</span>
          </div>
        )}
        {paymentOptions.points && (
          <div className="summary-row">
            <span className="summary-label">Points</span>
            <span className="summary-value">
              - ₹{(Point - finalPoints?.toFixed(2)) / 100}
            </span>
          </div>
        )}
        {paymentOptions.credit && (
          <div className="summary-row">
            <span className="summary-label">Credits</span>
            <span className="summary-value">
              - ₹{(credit?.data - finalCredit)?.toFixed(2)}
            </span>
          </div>
        )}
        <div className="promo-row">
          <label className="promo-label">Promo Code</label>
          <div
            className="promo-input-container"
            style={{ display: "flex", gap: "8px", alignItems: "center" }}
          >
            <input
              type="text"
              placeholder="Enter Code"
              value={
                selectedCoupon ? selectedCoupon?.promocode : promoCodeInput
              }
              onChange={(e) => setPromoCodeInput(e.target.value)}
              className="promo-input"
              // disabled={isApplyingCoupon || selectedCoupon}
            />

            {couponSuccess || couponError ? (
              <button
                onClick={removeCoupon}
                aria-label="Remove promo code"
                className="text-sm text-red-500 font-medium uppercase"
              >
                Remove
              </button>
            ) : (
              <button
                className="disabled:text-gray-400 text-sm text-blue-500 font-medium uppercase"
                onClick={() =>
                  applyCoupon(promoCodeInput || selectedCoupon?.promocode)
                }
                disabled={
                  isApplyingCoupon || (!promoCodeInput && !selectedCoupon)
                }
              >
                {isApplyingCoupon ? (
                  <Loader className="animate-spin" size={20} />
                ) : (
                  "apply"
                )}
              </button>
            )}
          </div>
        </div>
        {couponError && (
          <p className="capitalize text-red-500 text-sm">{couponError}</p>
        )}
        {couponSuccess && (
          <p className="capitalize text-green-700 text-sm">{couponSuccess}</p>
        )}

        <div className="total-row">
          <span className="total-label">Total Amount</span>

          <span className="total-value">
            ₹{Math.max(0, amountToPay).toFixed(2)}
          </span>
        </div>

        <div className="payment-options">
          {balance > 0 && (
            <div className="payment-option-row">
              <Checkbox
                size="small"
                color="primary"
                checked={paymentOptions.wallet}
                onChange={() => handlePaymentOptionChange("wallet")}
                aria-label="Use wallet balance"
                disabled={
                  disableCheckbox &&
                  consumedBy !== "wallet" &&
                  !paymentOptions.wallet
                }
              />
              <div className="payment-option">
                <span className="payment-label">Wallet</span>

                <span className="payment-value">₹{finalWallet}</span>
              </div>
            </div>
          )}
          {Point > 0 && Point >= minCap && (
            <div className="payment-option-row">
              <Checkbox
                size="small"
                color="primary"
                checked={paymentOptions.points}
                onChange={() => handlePaymentOptionChange("points")}
                // disabled={Point < minCap}
                disabled={
                  disableCheckbox &&
                  consumedBy !== "points" &&
                  !paymentOptions.points
                }
                aria-label="Use points"
              />

              <div className="payment-option">
                <span className="payment-label">Points</span>
                <span className="payment-value">
                  <span className="payment-value">{finalPoints}</span>
                </span>
              </div>
            </div>
          )}

          {credit.data > 0 && (
            <div className="payment-option-row">
              <Checkbox
                size="small"
                color="primary"
                checked={paymentOptions.credit}
                onChange={() => handlePaymentOptionChange("credit")}
                aria-label="Use credit"
                disabled={
                  disableCheckbox &&
                  consumedBy !== "credit" &&
                  !paymentOptions.credit
                }
              />

              <div className="payment-option">
                <span className="payment-label">Credits</span>
                <span className="payment-value">₹{finalCredit}</span>
              </div>
            </div>
          )}
        </div>

        <div className="checkout-section">
          <Button
            className="checkout-button"
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => {
              const shouldSkipPayment =
                paymentOptions.wallet && balance >= totals.finalTotal;

              dispatch(setSkipPayment(shouldSkipPayment));
              if (isBuyNow && productcart) {
                dispatch(
                  setCartItems({
                    ...buyNowData,
                    quantity: quantity,
                    ...productcart[0],
                    id: buyNowData.id,
                  }),
                );
              } else {
                dispatch(setCartItems(productcart));
              }
              dispatch(setCredit(paymentOptions.credit));

              dispatch(setWallet(paymentOptions.wallet));
              dispatch(setPoints(paymentOptions.points));

              navigate("/shipping_address", {
                state: {
                  totals,
                  amountToPay: amountToPay,
                  balance: balance,
                  paymentOptions,
                  credit,
                  consumedBy: consumedBy,
                  isBuyNow: isBuyNow,
                  quantity: quantity,
                },
              });
            }}
          >
            Continue to Checkout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderSummarySection;
